module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-4-blocks-bfa35e90ccdaeb778e575558bd176084.svg";